export default {"src":"/_next/static/media/BITMART.9f78448a.svg","height":29,"width":110,"blurWidth":0,"blurHeight":0};